import { Routes } from '@angular/router';

export const STIMULUS_ROUTES: Routes = [
  {
    path: 'channels/stimuli/view-edit/:stimulusId',
    loadComponent: () =>
      import('./stimulus-view-edit/stimulus-view-edit.component').then(
        (com) => com.StimulusViewEditComponent
      ),
    title: 'View/Edit Stimulus',
  },
  {
    path: 'channels/stimuli/add',
    loadComponent: () =>
      import('./stimulus-add/stimulus-add.component').then(
        (com) => com.StimulusAddComponent
      ),
    title: 'Add Stimulus',
  },
];
